import React from 'react';
import { Box, Button, CircularProgress, Typography, Chip } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import ClearIcon from '@mui/icons-material/Clear';
import DownloadIcon from '@mui/icons-material/Download';
import SaveIcon from '@mui/icons-material/Save';
import DescriptionIcon from '@mui/icons-material/Description';
import SavedQueriesMenu from './SavedQueriesMenu';

const QueryBuilderToolbar = ({
  onAddField,
  onClearFields,
  onExecuteQuery,
  onExportCSV,
  onSaveQuery,
  isExecuting,
  hasFields,
  hasSql,
  hasResults,
  savedQueries,
  currentQuery,
  onLoadQuery,
  onDeleteQuery,
  onRenameQuery,
  onDuplicateQuery,
  onToggleFavorite,
  onManageAll
}) => {
  return (
    <Box sx={{ mb: 2 }}>
      {currentQuery && (
        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant='body2' color='text.secondary'>
            Current Query:
          </Typography>
          <Chip
            icon={<DescriptionIcon />}
            label={currentQuery.name}
            color='primary'
            variant='outlined'
            size='small'
          />
        </Box>
      )}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 2
        }}
      >
      <Box sx={{ display: 'flex', gap: 1 }}>
        <Button
          variant='outlined'
          startIcon={<AddIcon />}
          onClick={onAddField}
        >
          Add Field
        </Button>
        <Button
          variant='outlined'
          startIcon={<SaveIcon />}
          onClick={onSaveQuery}
          disabled={!hasFields}
        >
          Save Query
        </Button>
        <SavedQueriesMenu
          savedQueries={savedQueries}
          onLoadQuery={onLoadQuery}
          onDeleteQuery={onDeleteQuery}
          onRenameQuery={onRenameQuery}
          onDuplicateQuery={onDuplicateQuery}
          onToggleFavorite={onToggleFavorite}
          onManageAll={onManageAll}
        />
        <Button
          variant='outlined'
          color='secondary'
          startIcon={<ClearIcon />}
          onClick={onClearFields}
          disabled={!hasFields}
        >
          Clear All
        </Button>
      </Box>
      <Box sx={{ display: 'flex', gap: 1 }}>
        <Button
          variant='outlined'
          color='success'
          startIcon={<DownloadIcon />}
          onClick={onExportCSV}
          disabled={!hasResults}
        >
          Export CSV
        </Button>
        <Button
          variant='contained'
          color='primary'
          startIcon={isExecuting ? <CircularProgress size={20} color='inherit' /> : <PlayArrowIcon />}
          onClick={onExecuteQuery}
          disabled={!hasSql || isExecuting}
        >
          {isExecuting ? 'Executing...' : 'Execute Query'}
        </Button>
      </Box>
    </Box>
    </Box>
  );
};

export default QueryBuilderToolbar;
